import get from 'lodash/get';
import includes from 'lodash/includes';
import last from 'lodash/last';
import { useEffect } from 'react';
import { getSchemaAtCursor } from '../path';

export const useFormikSync = ({
  context,
  fieldName,
  formValues,
  formik,
  validate,
}) => {
  useEffect(() => {
    const parentSchemaPath = context.schemaPath.slice(0, -2);
    const itemName = last(context.schemaPath);

    const schemaAtCursor = getSchemaAtCursor(
      context.schemaPath,
      validate.schema
    );

    const fieldValue = get(formValues, fieldName);

    const isRequired =
      includes(
        getSchemaAtCursor(parentSchemaPath.concat('required'), validate.schema),
        itemName
      ) ||
      (get(parentSchemaPath, [parentSchemaPath.length - 2]) === 'oneOf' &&
        includes(
          getSchemaAtCursor(
            parentSchemaPath.slice(0, -2).concat('required'),
            validate.schema
          ),
          itemName
        ));

    // Reset the formik formValue for this field if
    // the fieldName is the same but the schemaNode is different
    const existingSchemaPath = get(
      validate.fieldNameSchemaPathMap,
      fieldName,
      false
    );

    let resetField = false;

    if (existingSchemaPath) {
      if (existingSchemaPath.join('.') !== context.schemaPath.join('.')) {
        resetField = true;
        validate.fieldNameSchemaPathMap[fieldName] = context.schemaPath;
      }
    } else {
      validate.fieldNameSchemaPathMap[fieldName] = context.schemaPath;
    }

    if (
      (((isRequired ||
        schemaAtCursor.noPOBox ||
        schemaAtCursor.minLength >= 1 ||
        typeof schemaAtCursor.default !== 'undefined') &&
        (typeof fieldValue === 'undefined' ||
          (schemaAtCursor.enum &&
            fieldValue !== '' &&
            !schemaAtCursor.enum.includes(fieldValue)))) ||
        (schemaAtCursor.$customInput === 'Checkbox' && fieldValue === false) ||
        resetField) &&
      typeof get(formik, 'setFieldValue') === 'function'
    ) {
      let defaultValue = '';
      const index = get(context.keyPath, 'index', null);

      if (
        // For addAnother arrays with keyPath indexes
        // do not set default value for array items subsequent to the first
        // unless setDefault === 'always'
        index === '0' ||
        schemaAtCursor.setDefault === 'always' ||
        index === null
      ) {
        defaultValue = get(schemaAtCursor, 'default', '');
      }

      formik.setFieldValue(fieldName, defaultValue, false);
    }
  }, [get(formValues, fieldName)]);
};
